<template>
    <div style="font-family: Myanmar3;">
        <answer-header type="back"></answer-header>
        <img class="logo" src="../assets/logo.png">
        <div class="rule-content">
            <h2>{{title}}</h2>
            <div v-html="content"></div>
        </div>
        <!-- <div v-if="referer != 'Menu'" class="btn btn-blue btn-block" @click="_startAn">开始答题</div> -->
    </div>
</template>

<script>
import answerHeader from './Header'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Doc',
    components: {answerHeader},
    data(){
        return {
            referer: '',
            content: '',
        }
    },
    beforeRouteEnter (to, from, next){
        next(vm => {
            vm.referer = from.name
        })
   },
    computed: {
        ...mapState(['lang'])
    },
    created(){
        Utils.$ajax({
            url: '/share/teams-condition',
        }).done(res =>{
            if (res.code != 0){
                this.$toast(res.msg);
                return;
            }
            this.title = res.data.title;
            this.content = res.data.content;
        })
    },
    methods: {
        _startAn(){
            this.$router.push(`/answer`);
        },
    }
}
</script>

<style lang="scss" scoped>
    .rule-content{
        color: #000;
        padding-bottom: 20px;
        h2{
            font-size: rem(36);
            font-weight: bold;
        }
        p{
            margin: .5em 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Doc.vue